// Generated by purs version 0.13.8
"use strict";
var transparentLogoWithText = "https://cdn.discordapp.com/attachments/485859146558865408/707597859138043964/Screensasdfahot_1.png";
var transparentLogo = "https://cdn.discordapp.com/attachments/672889285438865453/708081533151477890/favicon.png";
var logoWithText = "https://cdn.discordapp.com/attachments/494734149978947584/705352232006320138/unknown.png";
var logo = "https://cdn.discordapp.com/attachments/494734149978947584/705349608267579453/unknown.png";
module.exports = {
    logo: logo,
    logoWithText: logoWithText,
    transparentLogoWithText: transparentLogoWithText,
    transparentLogo: transparentLogo
};
